import { render, staticRenderFns } from "./VerticalMenuHeader.vue?vue&type=template&id=ac540f20&"
import script from "./VerticalMenuHeader.vue?vue&type=script&lang=js&"
export * from "./VerticalMenuHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports